import { Logger } from '@thesavingsgroup/logger/Logger';

type ContentfulLogHandlerDependencies = {
  logger?: Logger;
};

export const contentfulLogHandler =
  ({ logger = new Logger() }: ContentfulLogHandlerDependencies) =>
  (level: string, data: string | Record<string, unknown> | undefined): void => {
    if (level === 'error') {
      logger.error('[REMOTE_CONFIGURATION_ERROR]', data);
    } else if (level === 'warning' || level === 'warn') {
      logger.warn('[REMOTE_CONFIGURATION]', data);
    } else {
      logger.info('[REMOTE_CONFIGURATION]', data);
    }
  };
